import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookS2Service } from './taf-book-s2.service';
import {ITAFBookS2} from './taf-book-s2-list';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-s2/taf-book-s2.component.html',
     template: require('./taf-book-s2.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    
})

export class TAFBookS2Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK s2';
    errorMessage: string;
    tafBookS2Arr: ITAFBookS2;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBooks2Service: TAFBookS2Service) {
                    
    }

    ngOnInit(): void{
        this._tafBooks2Service.getTAFBookS2()
         .subscribe(
                tafBookS2Arr => this.tafBookS2Arr = tafBookS2Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-s2/taf-book-s2.component.ts
 **/